import useDetectKeelMind from "./useDetectKeelMind";

function useKeelLogoSwitch(dark = false, backgroundState = false) {
    const isKeelMind = useDetectKeelMind();
    if (isKeelMind) {
        return `/images/keel-mind-logo-${
            dark && !backgroundState ? "blue" : "white"
        }.svg`;
    } else if (window.location.pathname.includes("lab")) {
        return `/images/keel-lab-logo-${
            dark && !backgroundState ? "blue" : "white"
        }.svg`;
    } else {
        return `/images/keel-logo-${
            dark && !backgroundState ? "blue" : "white"
        }.svg`;
    }
}

export default useKeelLogoSwitch;
